module.exports = __webpack_public_path__ + "static/media/happy-april-fools-beyonce.0b937a05.png";